import axios from 'axios';

export const getOauthApplication = async (accountId, oauthApplicationId) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/oauth-applications/${oauthApplicationId}`;
  return axios.get(url).then((response) => response.data);
};

export const createOauthApplication = async (accountId, oauthApplication) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/oauth-applications`;
  return axios.post(url, oauthApplication).then((response) => response.data);
};

export const deleteOauthApplication = async (accountId, oauthApplicationId) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/oauth-applications/${oauthApplicationId}`;
  return axios.delete(url).then((response) => response.data);
};

export const getOauthApplicationsByAccount = async (accountId) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/oauth-applications`;
  return axios.get(url).then((response) => response.data);
};

export const getOauthApplications = async (accountId, search) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/oauth-apps${search}`;
  return axios.get(url).then((response) => response.data);
};
